import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../styles/legal.css";
import logo from "../assets/PetfamLogo.png";
import { X } from "lucide-react";

export default function Terminos() {
  const navigate = useNavigate();
  const location = useLocation();

  // Sistema de animaciones de entrada
  const t = location.state?.transition;
  const screenUp = t === "screen" || t === "screen-up" || t === "up";
  const screenDown = t === "screen-down" || t === "down";

  const [enterClass, setEnterClass] = useState(
    screenDown ? "is-entering-down" : screenUp ? "is-entering" : ""
  );

  useEffect(() => {
    if (screenUp || screenDown) {
      const id = setTimeout(() => setEnterClass(""), 420);
      return () => clearTimeout(id);
    }
  }, [screenUp, screenDown]);

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  const lastUpdated = "7 de noviembre de 2025";


  return (
    <div className={`legal-shell ${enterClass}`}>

      {/* X para volver */}
      <button
        className="close-btn"
        onClick={() => navigate("/")}
        aria-label="Volver al inicio"
        title="Volver al inicio"
      >
        <X />
      </button>

      {/* header */}
      <header className="legal-header">
        <div className="legal-header-inner">
          <Link to="/" className="legal-logo" aria-label="Ir al inicio">
            <img src={logo} alt="Petfam logo" />
          </Link>
          <Link to="/crear-cuenta" className="legal-cta">
            Suscribirse
          </Link>
        </div>
      </header>

      {/* 2️⃣ contenido que hace el “pop” de entrada */}
      <main className="legal-main" role="main">
        <section className="legal-hero">
          <h1 className="legal-title">Política de reembolsos y cancelaciones</h1>
          <p className="legal-updated">Última actualización: {lastUpdated}</p>

          <div className="legal-content">

            <h3>1. Naturaleza del servicio</h3>
            <p>
              PETFAM funciona bajo un modelo de suscripción mensual recurrente, que da acceso a consultas
              virtuales con profesionales veterinarios o etólogos, además de herramientas digitales de gestión 
              (historia clínica y calendario).
            </p>

            <h3>2. Reembolsos</h3>
            <p>
              Dado que el servicio está disponible de forma continua durante el periodo de suscripción, no se
              realizan reembolsos por uso parcial, cancelación anticipada o falta de utilización por parte del usuario.
              Solo se contemplarán reembolsos excepcionales cuando exista un error comprobado en el cobro o
              una falla técnica atribuible a PETFAM que impida completamente el acceso al servicio.
            </p>

            <h3>3. Cancelación de la suscripción</h3>
            <p>
              El usuario puede cancelar su suscripción en cualquier momento desde su cuenta. La cancelación
              evitará el cobro del siguiente ciclo de facturación, pero no implica reembolso del periodo ya pagado.
            </p>

            <h3>4. Casos excepcionales</h3>
            <p>
              En caso de cobro duplicado o error en el sistema de pago, el usuario podrá solicitar revisión
              escribiendo a soporte@petfam.club dentro de los 5 días hábiles siguientes al cobro.
            </p>

            <h3>5. Pasarela de pagos</h3>
            <p>
              Los pagos son procesados a través de un tercero (Wompi).
              PETFAM no almacena datos financieros del usuario. Cualquier error en la transacción deberá ser
              gestionado inicialmente ante la pasarela correspondiente.
            </p>


            <div className="legal-footnote">
              PETFAM podrá actualizar estas políticas cuando sea necesario. Revise
              periódicamente esta página para conocer la versión vigente.
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
